<template>
  <main-layout
    controlsBg="light"
    :hasControlsBar="false"
    :breadcrumb="getBreadcrumb">
    <div class="container">
      <grid-row column-align="center">
        <grid-col col-size="4">
          <h1 class="header margin-top-xl marg">
            <chevron @click="$router.push({name: 'Workspace'})"/>
            {{ $t('health.exploreRecommendations.title') }}
          </h1>
          <alert
            v-if="alertVisible"
            :message="alertMessage"
            :type="alertType">
          </alert>
        </grid-col>
      </grid-row>
      <grid-row column-align="center">
        <grid-col col-size="4">
          <div class="flex">
            <v-select class="v-select--light"
                      :value="selectedUser" :onChange="changeUser" :searchable="true" :options="getUserSelectOptions"></v-select>
            <BtnPill :btnText="$t('commons.save')"
                     btn-size="s"
                     :disabled="!selectedUser"
                     v-on:click="updateRecommendedBlogs">
            </BtnPill>
          </div>
          <table-component
            :data="fetchData"
            sort-by="email"
            sort-order="asc"
            ref="postsTable"
            class="margin-top-m"
          >
            <table-column show="id" label="Id" :hidden="true"></table-column>
            <table-column show="title" :label="$t('variables.name')"></table-column>
            <table-column label="" :sortable="false" :filterable="false">
              <template slot-scope="row">
                <checkbox v-on:change="changeSelected($event, row.id)"
                          :checked="isRecommended(row.id)"
                          :id="String(row.id)"
                          check-size="m"/>
              </template>
            </table-column>
          </table-component>

        </grid-col>
      </grid-row>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import Chevron from '@/components/shared/Chevron';
import Checkbox from '@/components/shared/forms/Checkbox';
import BtnPill from '@/components/shared/buttons/BtnPill';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import pagination from '@/components/shared/table/pagination';
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableColumn from '@/components/shared/table/components/TableColumn';
import vSelect from 'vue-select';
import api from 'BRAND/api/academy';
import explorerApi from 'BRAND/api/healthExplorer';
import Alert from '@/components/shared/alert/Alert';
import {mapGetters} from 'vuex';

export default {
  name: 'ExploreRecommendedPostsUpdate',
  components: {
    MainLayout,
    Chevron,
    vSelect,
    Checkbox,
    BtnPill,
    GridCol,
    GridRow,
    Alert,
    TableComponent,
    TableColumn
  },
  data () {
    return {
      alertVisible: false,
      alertMessage: '',
      alertType: '',
      posts: [],
      recommendedPosts: [],
      selectorUsers: [],
      selectedUser: null,
      tablePageSize: 10,
      tableState: {
        filter: '',
        page: 1,
        sort: {
          order: '',
          fieldName: ''
        }
      }
    };
  },
  watch: {
    filteredPosts: {
      handler: function () {
        this.$refs.postsTable.refresh();
      }
    }
  },
  mounted () {
    explorerApi.getAccessibleUsers(this, this.filterPremium).then(data => {
      this.selectorUsers = data;
    });
    const languageCode = this.getLanguageCode;
    api.getPosts(this, languageCode).then((data) => {
      this.posts = data.body;
    });
    const alert = this.$route.params.alert;
    if (alert !== undefined) {
      showAlert(this, this.$t(alert), 'success');
    }
  },
  computed: {
    ...mapGetters([
      'getLanguageCode'
    ]),
    getBreadcrumb () {
      return [
        {name: this.$t('menu.workspace'), link: '/workspace'},
        {name: this.$t('health.exploreRecommendations.title'), disabled: true}
      ];
    },
    getUserSelectOptions () {
      return this.selectorUsers;
    },
    filteredPosts () {
      return this.selectedUser ? this.posts : [];
    }
  },
  methods: {
    changeUser (user) {
      this.selectedUser = user;
      if (user != null) {
        api.getUserRecommendedPosts(this, Number(user.id)).then((data) => {
          this.recommendedPosts = data.body;
        });
      }
    },
    isRecommended (id) {
      return this.recommendedPosts.includes(id);
    },
    changeSelected (isChecked, postId) {
      if (isChecked) {
        this.recommendedPosts.push(postId);
      } else {
        this.recommendedPosts = this.recommendedPosts.filter(id => id !== postId);
      }
    },
    updateRecommendedBlogs () {
      const user = this.selectedUser;
      if (user != null && Number(user.id).toString() !== 'NaN') {
        api.updateUserRecommendedPosts(this, Number(user.id), this.recommendedPosts)
          .then(() => showAlert(this, this.$t('health.exploreRecommendations.successUpdating', {name: user.label}), 'success'))
          .catch((error) => showAlert(this, error.data.message, 'error'));
      } else {
        showAlert(this, this.$t('health.exploreRecommendations.errorUpdating'), 'error');
      }
    },
    fetchData ({ page, filter, sort }) {
      const tablePage = pagination.createPage(
        this.filteredPosts,
        this.tableState,
        ['name', 'email'],
        this.tablePageSize,
        { page, filter, sort });
      this.tableState = tablePage.state;
      return tablePage.result;
    }
  }
};

const showAlert = (context, message, type) => {
  context.alertVisible = true;
  context.alertMessage = message;
  context.alertType = type;
  context.showAlert = true;
  setTimeout(() => {
    context.alertVisible = false;
  }, 2500);
};

</script>

<style lang="scss" scoped>
@import "src/stylesheets/variables";

.users-box {
  max-height: $height5 * 10;
  width: fit-content;
}

.users-box ::-webkit-scrollbar {
  width: 10px;
}

.users-box ::-webkit-scrollbar-track {
  background: white;
}

.users-box ::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background: #2c62ba
}

</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/ExploreRecommendedPostsUpdate.vue